export enum ERainforestApiVersion {
	Version20241016 = '2024-10-16',
}